import React from 'react'
import styled from 'styled-components'
import { CREATOR_REGISTRATION_URL, CREATOR_AND_BUSINESS_FAQ_URL, CONTACT_URL } from '../../../../const'
import { mediaPc } from '../../../../lib/MediaQuery'

const FLOW_STEPS = [
  {
    num: '01',
    title: '申請',
    text: '専用の応募フォームから、必要事項をご入力のうえご応募ください。',
  },
  {
    num: '02',
    title: '審査',
    text: 'ご応募内容を弊社にて確認いたします。確認後、あらためてご連絡いたします。',
  },
  {
    num: '03',
    title: 'アカウント発行',
    text: '審査完了のご連絡後、プロフィールのご登録と同時にアカウントが有効になります。',
  },
  {
    num: '04',
    title: '販売開始',
    text: '写真や動画などの商品を登録して、すぐに販売を開始できます。',
  },
]

const Wrapper = styled.div`
  .apply-button {
    display: block;
    text-align: center;
    margin: 0 auto;
    padding: 4vw 0;
    border-radius: 4px;
    background-color: ${(props): string => props.theme.backgroundColors.primary};
    color: ${(props): string => props.theme.textColors.black};
    font-weight: bold;
    font-size: 3.6vw;
    letter-spacing: 0.05em;
  }
  .top {
    .apply-button {
      margin: 0 auto;
      background-color: ${(props): string => props.theme.backgroundColors.bodyBg};
      color: ${(props): string => props.theme.textColors.black};
    }
    padding: 18.6vw 4.35vw;
    text-align: center;
    background-color: ${(props): string => props.theme.backgroundColors.primary};
    color: ${(props): string => props.theme.textColors.black};
    .badge {
      display: inline-block;
      margin: 0 0 4vw;
      padding: 1.8vw 4.8vw;
      border-radius: 999px;
      background-color: ${(props): string => props.theme.backgroundColors.bodyBg};
      color: ${(props): string => props.theme.textColors.black};
      font-weight: bold;
      font-size: 3.6vw;
      letter-spacing: 0.05em;
    }
    .title {
      font-size: 6.4vw;
      font-weight: bold;
      letter-spacing: 0.08em;
      line-height: 1.5;
      margin: 0 0 4vw;
    }
    .lead {
      font-size: 3.6vw;
      line-height: 1.8;
      margin: 0 0 7.2vw;
    }
  }
  .feature {
    padding: 15.6vw 0;
    .inner {
      width: 88.9vw;
      margin: 0 auto;
      .title {
        text-align: center;
        font-size: 5.4vw;
        font-weight: bold;
        margin: 0 0 8.3vw;
      }
      .block {
        display: flex;
        align-items: flex-start;
        gap: 4vw;
        background-color: ${(props): string => props.theme.backgroundColors.bodyBg};
        margin: 0 0 6.4vw;
        padding: 6vw 6vw;
        border-radius: 10px;
        box-shadow: 8px 8px 15px 0px rgba(0, 0, 0, 0.1);
        &:last-child {
          margin-bottom: 0;
        }
        .num {
          flex-shrink: 0;
          font-size: 9.6vw;
          font-weight: bold;
          color: ${(props): string => props.theme.textColors.black};
        }
        .text {
          .step-title {
            font-size: 4.2vw;
            font-weight: bold;
            margin: 0 0 1.6vw;
          }
          p {
            font-size: 3.2vw;
            line-height: 1.7;
            letter-spacing: 0.05em;
          }
        }
      }
    }
  }
  .reward {
    padding: 12vw 4.35vw;
    text-align: center;
    background-color: ${(props): string => props.theme.backgroundColors.gray};
    .title {
      font-size: 4.2vw;
      font-weight: bold;
      margin: 0 0 3vw;
    }
    .rate {
      font-size: 11vw;
      font-weight: bold;
      color: ${(props): string => props.theme.textColors.black};
      margin: 0 0 3vw;
      span {
        font-size: 5.6vw;
      }
    }
    .note {
      font-size: 2.9vw;
      line-height: 1.7;
      color: ${(props): string => props.theme.textColors.gray};
    }
  }
  .about-product {
    padding: 4.6vw 0;
    .inner {
      width: 87.1vw;
      margin: 0 auto;
      padding: 7.8vw 5.98vw 9.62vw;
      border-radius: 10px;
      background-color: ${(props): string => props.theme.backgroundColors.bodyBg};
      text-align: center;
      .title {
        font-weight: bold;
        letter-spacing: 0.1em;
        font-size: 5.4vw;
        padding: 0 0 5.9vw;
      }
      .apply-button {
        margin: 0 auto 7.54vw;
      }
      .detail {
        p {
          font-size: 3.12vw;
          line-height: 170%;
          letter-spacing: 0.1em;
          &:last-child {
            font-weight: normal;
            padding: 5.2vw 0 0;
          }
          a {
            color: ${(props): string => props.theme.textColors.black};
          }
        }
      }
    }
  }
  ${mediaPc`
    .apply-button {
      width: 310px;
      padding: 16px 0;
      font-size: 15px;
    }
    .top {
      padding: 80px 20px;
      .badge {
        margin: 0 0 20px;
        padding: 8px 24px;
        font-size: 16px;
      }
      .title {
        font-size: 40px;
        margin: 0 0 20px;
      }
      .lead {
        font-size: 16px;
        margin: 0 0 32px;
      }
    }
    .feature {
      padding: 80px 0;
      .inner {
        max-width: 760px;
        .title {
          font-size: 28px;
          margin: 0 0 40px;
        }
        .block {
          gap: 24px;
          padding: 32px;
          margin: 0 0 24px;
          .num {
            font-size: 48px;
          }
          .text {
            .step-title {
              font-size: 20px;
              margin: 0 0 8px;
            }
            p {
              font-size: 15px;
            }
          }
        }
      }
    }
    .reward {
      padding: 60px 20px;
      .title {
        font-size: 20px;
      }
      .rate {
        font-size: 56px;
        span {
          font-size: 24px;
        }
      }
      .note {
        font-size: 13px;
        max-width: 600px;
        margin: 0 auto;
      }
    }
    .about-product {
      padding: 41px 0 91px;
      .inner {
        max-width: 705px;
        padding: 43px 70px 55px;
        .title {
          font-size: 24px;
          padding: 0 0 18px;
        }
        .apply-button {
          margin: 0 auto 30px;
        }
        .detail {
          p {
            font-size: 14px;
            &:last-child {
              padding: 23px 0 0;
            }
          }
        }
      }
    }
  `}
`

export const UserCreatorRecruitmentLpTpl: React.FC = () => {
  return (
    <Wrapper>
      <div className="top">
        <div className="badge">累計クリエイター登録1,000人突破</div>
        <p className="title">
          あなたの"推される"を
          <br />
          お仕事に。
        </p>
        <p className="lead">
          写真や動画、ライブトークで
          <br />
          ファンとつながるクリエイターを募集しています。
        </p>
        <a className="apply-button sp" href={CREATOR_REGISTRATION_URL} target="_blank" rel="noopener noreferrer">
          今すぐ応募する
        </a>
      </div>
      <div className="feature">
        <div className="inner">
          <p className="title">クリエイター登録の流れ</p>
          {FLOW_STEPS.map((step) => (
            <div className="block" key={step.num}>
              <p className="num">{step.num}</p>
              <div className="text">
                <p className="step-title">{step.title}</p>
                <p>{step.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="reward">
        <p className="title">還元率</p>
        <p className="rate">
          70<span>%〜</span>
        </p>
        <p className="note">
          販売価格に対する還元率です。クリエイターごとの条件により異なる場合がございますので、詳細は審査完了後にご案内いたします。
        </p>
      </div>
      <div className="about-product">
        <div className="inner">
          <p className="title">クリエイターとして登録する</p>
          <a className="apply-button" href={CREATOR_REGISTRATION_URL} target="_blank" rel="noopener noreferrer">
            今すぐ応募する
          </a>
          <div className="detail">
            <p>
              その他よくある質問は
              <a href={CREATOR_AND_BUSINESS_FAQ_URL} target="_blank" rel="noopener noreferrer">
                こちら
              </a>
              <br />
              お問い合わせは
              <a href={CONTACT_URL} target="_blank" rel="noopener noreferrer">
                こちら
              </a>
            </p>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}
